(function () {
  var FOOTER_ID = 'blog-reading-progress';
  var CONTENT_SELECTOR = '[data-article-content], .article-template-content';
  var START_THRESHOLD = 6;
  var END_THRESHOLD = 6;
  var ticking = false;
  var footerVisible = false;

  function getFooter() {
    return document.getElementById(FOOTER_ID);
  }

  function getContentEl() {
    return document.querySelector(CONTENT_SELECTOR);
  }

  function getTrack() {
    var footer = getFooter();
    return footer ? footer.querySelector('[data-reading-track]') : null;
  }

  function getBar() {
    var footer = getFooter();
    return footer ? footer.querySelector('[data-reading-bar]') : null;
  }

  function hideFooter(footer, resetProgress, force) {
    if (!footer) return;
    if (!force && !footerVisible) return;

    footerVisible = false;
    footer.classList.add('is-hidden');
    footer.setAttribute('aria-hidden', 'true');

    if (resetProgress) {
      footer.style.setProperty('--progress', '0%');
      var track = getTrack();
      if (track) track.setAttribute('aria-valuenow', '0');
    }
  }

  function showFooter(footer) {
    if (!footer) return;
    if (footerVisible) return;

    footerVisible = true;
    footer.classList.remove('is-hidden');
    footer.setAttribute('aria-hidden', 'false');
  }

  function updateProgress() {
    ticking = false;
    var footer = getFooter();
    var content = getContentEl();
    var bar = getBar();
    var track = getTrack();

    if (!footer || !content || !bar) {
      hideFooter(footer, true);
      return;
    }

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var rect = content.getBoundingClientRect();
    var contentHeight = content.offsetHeight;

    if (contentHeight <= 0) {
      hideFooter(footer, true);
      return;
    }

    // Not started: content top still below viewport top
    if (rect.top > START_THRESHOLD) {
      hideFooter(footer, true);
      return;
    }

    // Finished: content bottom scrolled past viewport top
    if (rect.bottom <= -END_THRESHOLD) {
      hideFooter(footer, false);
      return;
    }

    var scrollable = contentHeight - viewportHeight;
    var progress = 0;

    if (scrollable <= 0) {
      progress = 1;
    } else {
      progress = Math.max(0, Math.min(1, -rect.top / scrollable));
    }

    var percent = progress * 100;
    footer.style.setProperty('--progress', percent + '%');

    if (track) {
      track.setAttribute('aria-valuenow', Math.round(percent));
    }

    showFooter(footer);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    }
  }

  function init() {
    var footer = getFooter();
    var content = getContentEl();
    if (!footer || !content) return;

    footerVisible = false;
    hideFooter(footer, true, true);
    updateProgress();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
